export interface ITableClickEvent {
    dataSetId: string;
    dataSetCellId?: string;
    dataSetCellValue?: string;
    positionX: number;
    positionY: number;
    isFixed: boolean;
    disableColors?: boolean;
    disableEdit?: boolean;
    /** True when logged-in user is the dataset creator (edit/delete allowed) */
    isOwner?: boolean;
}

export class TableClickEvent implements ITableClickEvent {
    public dataSetId: string;
    public dataSetCellId?: string;
    public dataSetCellValue?: string;
    public positionX: number;
    public positionY: number;
    public isFixed: boolean;
    public disableColors?: boolean;
    public disableEdit?: boolean;
    public isOwner?: boolean;


    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ITableClickEvent);
    constructor(obj?: any) {
        this.dataSetId = obj && obj.dataSetId || '';
        this.dataSetCellId = obj && obj.dataSetCellId || undefined;
        this.dataSetCellValue = obj && obj.dataSetCellValue || undefined;
        this.positionX = obj && obj.positionX || 0;
        this.positionY = obj && obj.positionY || 0;
        this.isFixed = obj && obj.isFixed || false;
        this.disableColors = obj && obj.disableColors ? obj.disableColors : false;
        this.disableEdit = obj && obj.disableEdit ? obj.disableEdit : false;
        this.isOwner = obj && obj.isOwner != null ? obj.isOwner : false;
    }
}
